import React from "react";
import { useMediaQuery } from "react-responsive";
import Button from "./common/Button";
import { getSocialMedias } from "../backend/socialMedia/socialMedia";
import { SocialMedia } from "../types/socialMedia/socialMedia";
import SocialMediaRow from "./common/SocialMediaRow";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToRef, getScrollRefByKey } from "../backend/scrollToRef";
import { getCaseList } from "../backend/services/caseCatergories";
import formatPhoneNumber from "../utils/formatNumber";
import { getPatronatInfoByName } from "../backend/info/patronatInfo";

const PhoneButton = ({ link, text, ...props }) => {
  return (
    <Button
      text={text}
      external_link={link}
      border="3px solid var(--white)"
      hoverBorder="3px solid var(--white)"
      textColor="var(--white)"
      hoverTextColor="var(--white)"
      fontWeight="bold"
      fontSize={"min(2.5rem, 9vw)"}
      padding="1rem 1rem"
      iconPath="/assets/icons/tel.svg"
      iconProps={{
        width: "min(2.5rem,10vw)",
        height: "min(2.5rem,10vw)",
        marginRight: "0.5rem",
      }}
      iconColor="var(--white)"
      hoverIconColor="var(--white)"
      containerProps={props}
    />
  );
};

const ServiceFooter = () => {
  const media = getSocialMedias();
  const isVertical = useMediaQuery({ query: "(max-width: 1250px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 850px)" });
  const isMedium = useMediaQuery({ query: "(max-width: 600px)" });
  const isSmall = useMediaQuery({ query: "(max-width: 450px)" });

  const location = useLocation();
  const navigate = useNavigate();
  const cases = getCaseList();

  return (
    <footer style={{ ...styles.footerWrapper, paddingTop: isMobile ? "2rem" : "3rem" }}>
      <div style={{ ...styles.footerContainer, paddingBottom: isMobile ? "2rem" : "3rem" }}>
        {isMobile && (
          <img
            src={"/assets/icons/210-logo-big-bw.svg"}
            style={{
              maxHeight: isMobile ? "clamp(4rem, 13vw, 8rem)" : "9rem",
            }}
          />
        )}
        {/* {!isMobile && <a style={styles.footerHeader}>Переглянути звіти</a>} */}
        {/* <hr style={styles.divider} /> */}
        {isMobile && <hr style={styles.divider} />}
        <div style={{ ...styles.topRow, flexDirection: isMobile ? "column" : "row" }}>
          <div
            style={{
              ...styles.leftColumn,
              alignItems: "start",
            }}
          >
            <p
              style={{
                ...styles.heading,
                marginTop: isMobile ? "0rem" : "1rem",
                marginBottom: isMobile ? "1.5rem" : "2rem",
                fontSize: isMedium ? "7vw" : isVertical ? "2.5rem" : "3rem",
              }}
            >
              СЛУЖБА СУПРОВОДУ
              <br />
              ВІЙСЬКОВОСЛУЖБОВЦІВ
              <br />
              ТА ЧЛЕНІВ ЇХНІХ СІМЕЙ
            </p>

            <div
              style={{
                display: "flex",
                flexDirection: isVertical ? "column" : "row",
                gap: isVertical ? "2rem" : "2rem",
                marginBottom: isMobile ? "2rem" : "3rem",
              }}
            >
              <PhoneButton
                link={formatPhoneNumber(getPatronatInfoByName("phone1"))}
                text={getPatronatInfoByName("phone1")}
                width={isMedium ? "var(--main-container-width)" : ""}
              />
              <PhoneButton
                link={formatPhoneNumber(getPatronatInfoByName("phone2"))}
                text={getPatronatInfoByName("phone2")}
                width={isMedium ? "var(--main-container-width)" : ""}
              />
            </div>
            <a
              href={"mailto:" + getPatronatInfoByName("email")}
              style={{ ...styles.emailText, marginBottom: isMobile ? "1rem" : "2rem" }}
            >
              {getPatronatInfoByName("email")}
            </a>
            {isMobile && (
              <SocialMediaRow
                rowStyle={{
                  marginBottom: isMobile ? "" : "1rem",
                  marginTop: isMobile ? "" : "1rem",
                  position: "relative",
                  left: isMobile ? "" : "-30px",
                  width: "var(--main-container-width)",
                  justifyContent: isMobile ? "space-between" : "start",
                }}
                useFooter={true}
                size={"min(6rem, 18vw)"}
                gap={isMobile ? "0rem" : "2rem"}
              />
            )}
            {isMobile && <hr style={{ ...styles.divider, margin: "1rem 0rem" }} />}
            {isMobile && (
              <div style={styles.linkList}>
                <Button
                  text={`ЗВЕРНУТИСЬ ДО СЛУЖБИ СУПРОВОДУ`}
                  external_link={
                    "https://docs.google.com/forms/d/e/1FAIpQLSfPSOdw-BQ5cgX23s8uDB_uGVHbsxG735MJ2vcdbsHHaozl-g/viewform"
                  }
                  textColor="var(--white)"
                  hoverTextColor="var(--black)"
                  display="inline-flex"
                  fontSize={isSmall ? "min(1.5rem, 7vw)" : isMedium ? "2rem" : "2.5rem"}
                  fontWeight="normal"
                  padding="1rem 0rem"
                  fontFamily="UAFSans-Book"
                  textAlign="start"
                />
                {cases.map((item) => (
                  <Button
                    text={item.name.toUpperCase()}
                    onClick={() => {
                      if (location.pathname === "/patronat") {
                        scrollToRef(getScrollRefByKey(item.navigationState), item.navigationState);
                      } else navigate("/patronat", { state: { scrollTo: item.navigationState } });
                    }}
                    textColor="var(--white)"
                    hoverTextColor="var(--black)"
                    display="inline-flex"
                    fontSize={isSmall ? "min(1.5rem, 7vw)" : isMedium ? "2rem" : "2.5rem"}
                    fontWeight="normal"
                    padding="1rem 0rem"
                    fontFamily="UAFSans-Book"
                    textAlign="start"
                  />
                ))}
                <Button
                  text="ПІДТРИМАТИ"
                  external_link={getPatronatInfoByName("supportLink")}
                  textColor="var(--orange)"
                  hoverTextColor="var(--white)"
                  display="inline-flex"
                  fontSize={isSmall ? "min(1.5rem, 7vw)" : isMedium ? "2rem" : "2.5rem"}
                  fontWeight="normal"
                  padding="1rem 0rem"
                  fontFamily="UAFSans-Book"
                />
                {/* <Button
                  text="ЗВІТ"
                  onClick={() => {
                    navigate("/anketa");
                  }}
                  textColor="var(--orange)"
                  hoverTextColor="var(--white)"
                  display="inline-flex"
                  fontSize={isSmall ? "min(1.5rem, 7vw)" : isMedium ? "2rem" : "2.5rem"}
                  fontWeight="normal"
                  padding="1rem 0rem 0rem"
                  fontFamily="UAFSans-Book"
                /> */}
              </div>
            )}
          </div>
          {!isMobile && (
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
              <div
                style={{
                  ...styles.rightColumn,
                  marginBottom: "3rem",
                  marginTop: isMobile ? "0rem" : "1rem",
                  gap: isSmall ? "2rem" : isMedium ? "2rem" : "3rem",
                }}
              >
                {media.map((item) => (
                  <a style={styles.mediaText} href={item.redirectLink} target="_blank">
                    {item.name}
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>

        <hr style={styles.divider} />

        <div
          style={{
            ...styles.bottomRow,
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "2rem" : "3rem",
          }}
        >
          <p
            style={{
              ...styles.policyText,
              fontSize: isSmall ? "1rem" : isMedium ? "1.2rem" : "1.25rem",
              order: isMobile ? "1" : "0",
            }}
          >
            © {new Date().getFullYear()} 210polk.mil.gov.ua
          </p>
          <div
            style={{
              ...styles.policyLinks,
              flexDirection: isMobile ? "column" : "row",
              gap: isMobile ? "2rem" : "2rem",
              order: isMobile ? "0" : "1",
            }}
          >
            <a
              href="/cookie-policy"
              style={{
                ...styles.policyText,
                fontSize: isSmall ? "1rem" : isMedium ? "1.2rem" : "1.25rem",
              }}
              onMouseOver={(e) => {
                (e.currentTarget.children[0] as HTMLElement).style.width = isMobile ? "0%" : "100%";
              }}
              onMouseOut={(e) => {
                (e.currentTarget.children[0] as HTMLElement).style.width = "0%";
              }}
            >
              Cookie policy
              <span style={styles.policyUnderline} />
            </a>
            <a
              href="/privacy-policy"
              style={{
                ...styles.policyText,
                fontSize: isSmall ? "1rem" : isMedium ? "1.2rem" : "1.25rem",
              }}
              onMouseOver={(e) => {
                (e.currentTarget.children[0] as HTMLElement).style.width = isMobile ? "0%" : "100%";
              }}
              onMouseOut={(e) => {
                (e.currentTarget.children[0] as HTMLElement).style.width = "0%";
              }}
            >
              Політика конфіденційності
              <span style={styles.policyUnderline} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ServiceFooter;

const styles: Record<string, React.CSSProperties> = {
  footerWrapper: {
    width: "100%",
    backgroundColor: "var(--black)",
    color: "var(--white)",
    paddingTop: "2rem",
    display: "flex",
    justifyContent: "center",
  },
  footerContainer: {
    width: "var(--main-container-width)",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    paddingBottom: "2rem",
  },
  topRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  leftColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    minWidth: "250px",
  },
  rightColumn: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "3rem",
  },
  emailText: {
    color: "var(--white)",
    fontSize: "min(7vw, 2.5rem)",
    fontWeight: "bold",
    marginBottom: "1rem",
    textDecoration: "none",
  },
  feedbackContainer: {
    display: "flex",
    flexDirection: "column",
    height: "3rem",
  },
  feedbackText: {
    color: "var(--white)",
    fontSize: "min(1.25rem, 5vw)",
    textAlign: "right",
  },
  divider: {
    width: "100%",
    height: "1.5px",
    borderColor: "var(--orange)",
    margin: "2rem 0",
  },
  bottomRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "1rem",
    // alignItems: "center",
  },
  policyLinks: {
    display: "flex",
    // alignItems: "center",
    gap: "2rem",
  },
  policyText: {
    display: "flex",
    flexDirection: "column",
    color: "var(--orange)",
    textDecoration: "none",
    fontSize: "min(1.375rem, 5vw)",
    whiteSpace: "pre",
  },
  policyUnderline: {
    position: "relative",
    bottom: 0,
    left: 0,
    height: "2px",
    width: "0%",
    backgroundColor: "var(--orange)",
    transition: "all 0.3s ease",
  },
  footerHeader: {
    fontWeight: "bold",
    color: "var(--orange)",
    fontSize: "2rem",
    margin: "1rem 0rem",
  },
  heading: {
    fontWeight: "normal",
    color: "var(--white)",
    fontSize: "3rem",
    marginBottom: "1rem",
  },
  mediaText: {
    fontWeight: "normal",
    color: "var(--white)",
    fontSize: "2.5rem",
    textDecoration: "none",
  },
  linkList: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
  },
};
